export const PLANS_PAGE_TABS = {
  contracts: 'contracts',
  plans: 'plans',
} as const;

export type PlansPageTabs = typeof PLANS_PAGE_TABS[keyof typeof PLANS_PAGE_TABS];